import { Body, breakpoints, Dialog, Spacer, useAlert } from '@spritz-finance/ui'
import styled from 'styled-components'
import { LinkBill } from './LinkBill'

interface LinkBillDialogProps {
    open: boolean
    onClose: () => void
    foundBills: boolean | null
}

const DialogContentWrapper = styled.div`
    max-height: 80vh;
    min-height: 195px;
    padding: 24px;
    padding-top: 8px;
    overflow: auto;
    overflow-x: clip;
    max-width: 670px;
    ${breakpoints.med} {
        max-width: unset;
        padding: 16px;
    }
`

const SelectBillHeader = ({
    foundBills,
    numBillsText,
}: {
    foundBills: boolean | null
    numBillsText?: string
}) => {
    if (foundBills === true)
        return (
            <Body.SmBold size={14} align="center">
                We were able to automatically find {numBillsText} for you! Select one below to make
                a payment.
            </Body.SmBold>
        )
    if (foundBills === false)
        return (
            <Body.SmBold size={14} align="center">
                We were not able to find any bills for you. Don't worry though, you can still add
                new bills by finding your bill provider below.
            </Body.SmBold>
        )
    return (
        <Body.SmBold size={16} align="center">
            Let's find a new bill for you to pay
        </Body.SmBold>
    )
}

export const LinkBillDialog: React.VFC<LinkBillDialogProps> = ({ open, onClose, foundBills }) => {
    const alert = useAlert()

    const onLinkBill = () => {
        onClose()
        alert.success('Successfully added your bill!')
    }

    return (
        <Dialog open={open} onClose={onClose}>
            <Dialog.Content minWidth={560} contentPadding={false}>
                <Dialog.Title>Add a bill</Dialog.Title>
                <Spacer height={24} />
                <DialogContentWrapper>
                    <LinkBill
                        onLinkBill={onLinkBill}
                        onCantPayBill={onLinkBill}
                        selectBillHeader={(_, numBillsText) => (
                            <SelectBillHeader foundBills={foundBills} numBillsText={numBillsText} />
                        )}
                    />
                    <Spacer height={16} />
                </DialogContentWrapper>
            </Dialog.Content>
        </Dialog>
    )
}
